import { LocationContext } from "contexts/LocationProvider"
import { ClosetLocation, getClosestPlaces } from "lib/utils"
import { useContext, useEffect, useRef } from "react"
import "swiper/css"
import "swiper/css/effect-coverflow"
import "swiper/css/effect-fade"
import { Navigation } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import { useIsDesktop } from "ui"
import SwiperCard from "./SwiperStationCard"

interface SwiperContainerProps {
    locations: ClosetLocation[]
    onClick?: () => void,
}

const SwiperContainer = ({ locations }: SwiperContainerProps) => {

    const { selectedLocation, setSelectedLocation } = useContext(LocationContext)
    const isDesktop = useIsDesktop()
    const swiperRef = useRef<any>(null);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.swiper.slideTo(0); // Set the initial slide to index 0
        }
    }, [selectedLocation]);


    const locArray = getClosestPlaces({
        locations,
        lat: selectedLocation?.geoLocation.latitude,
        lon: selectedLocation?.geoLocation.longitude,
        withoutStation: isDesktop // show current station only in mobile
    })
    if (!selectedLocation) {
        return null
    }
    return (
        <Swiper
            key={1}
            ref={swiperRef}
            style={{ padding: 0, width: "100%" }}
            modules={[Navigation]}
            navigation={{
                nextEl: `.arrow-left`,
                prevEl: `.arrow-right`,
            }}
            slidesPerView={1.3}
            spaceBetween={20}
            role="region"
            aria-label="רשימה של תחנות" // Add a desc
        >
            {
                locArray.map((loc, index: number) => {
                    return (
                        <SwiperSlide key={index.toString()}>
                            <SwiperCard location={loc} onClick={() => setSelectedLocation(loc)}></SwiperCard>
                        </SwiperSlide>
                    )
                })}
        </Swiper>
    )
}
export default SwiperContainer
